import { useAtomValue } from "jotai";
import { campaignCodeAtom, campaignValidationAtom } from "./store";
import { textStyles } from "../../styles/typography";
import { ccn } from "../../styles/utils";

export default function CampaignCodeInfo() {
  const campaignCode = useAtomValue(campaignCodeAtom);
  const campaignValidation = useAtomValue(campaignValidationAtom);

  // Only show success message for valid campaign codes
  if (campaignCode && campaignValidation.isValid === true) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
        <div
          className={ccn(
            textStyles.sub1,
            'text-green-800 font-medium flex items-center gap-2'
          )}
        >
          🎉 Thank you for using the referral. You will see more information on the next step
        </div>
      </div>
    );
  }

  // Don't show anything for loading or no campaign codes
  return null;
}
